import { HttpClient } from '@opallabs/api'
import { track } from '@opallabs/quanta'
import removeJsonApiEntities from '../removeJsonApiEntities'

const deleteNotification = (id) =>
  HttpClient().delete(`/api/v1/notifications/${id}`)

const trackNotificationRemoval = (id) => {
  track('Personal Panel: Notification Dismissed', {
    'Notification Id': id,
  })
}

const removeNotification = (id) => (dispatch) => {
  // Optimistic update - remove from UI immediately for better UX
  dispatch(removeJsonApiEntities({ id, type: 'notifications' }))

  return deleteNotification(id)
    .then((response) => {
      trackNotificationRemoval(id)
      return response
    })
    .catch((err) => {
      console.error('Failed to delete notification on server:', err)
      throw err
    })
}

export default removeNotification
